<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { RouterLink, RouterView } from 'vue-router'
import { useReferenceStore } from '@/stores/reference'
import { API_BASE_URL } from '@/api/client'

const reference = useReferenceStore()
const menuOpen = ref(false)

const NAV = [
  { to: '/', label: 'Dashboard', exact: true },
  { to: '/clients', label: 'Clients' },
  { to: '/projects', label: 'Projects' },
  { to: '/deliverables', label: 'Delivery' },
  { to: '/languages', label: 'Languages' },
  { to: '/casting', label: 'Casting' },
  { to: '/outstanding', label: 'Still needed' },
  { to: '/intake', label: 'Intake' },
]

onMounted(() => void reference.ensureLoaded())
</script>

<template>
  <div class="app-shell">
    <header class="app-masthead">
      <nav class="navbar" role="navigation" aria-label="Main">
        <div class="app-container is-flex-grow-1">
          <div class="navbar-brand">
            <RouterLink class="navbar-item masthead-brand" to="/">
              <span class="masthead-brand__mark" aria-hidden="true" />
              Bedouin
            </RouterLink>
            <a
              role="button"
              class="navbar-burger"
              :class="{ 'is-active': menuOpen }"
              aria-label="Menu"
              :aria-expanded="menuOpen"
              @click="menuOpen = !menuOpen"
            >
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
              <span aria-hidden="true" />
            </a>
          </div>

          <div class="navbar-menu" :class="{ 'is-active': menuOpen }">
            <div class="navbar-start">
              <RouterLink
                v-for="item in NAV"
                :key="item.to"
                class="navbar-item"
                :to="item.to"
                :active-class="item.exact ? '' : 'is-active'"
                exact-active-class="is-active"
                @click="menuOpen = false"
              >
                {{ item.label }}
              </RouterLink>
            </div>

            <div class="navbar-end">
              <RouterLink class="navbar-item" to="/settings" @click="menuOpen = false">
                Vendors &amp; markets
              </RouterLink>
              <div class="navbar-item">
                <span class="masthead-user">{{ reference.user?.name ?? 'Connecting' }}</span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>

    <!--
      A failed reference load almost always means the Worker is not running,
      which is the single most common local-dev stumble. Name the URL the app
      is actually pointed at and the command that fixes it.
    -->
    <div v-if="reference.error" class="notification is-warning is-light is-radiusless mb-0 py-3">
      <div class="app-container">
        <strong>Cannot reach the API.</strong>
        Tried <code>{{ API_BASE_URL }}</code>. Start it with <code>npm run dev:api</code>, or point
        <code>VITE_API_BASE_URL</code> somewhere else.
      </div>
    </div>

    <main class="app-main">
      <div class="app-container">
        <RouterView />
      </div>
    </main>
  </div>
</template>
